export const PATHS = {
  loading: '/',
  notfound: '/404',
  acionamento: '/acionamento',
  acionamento_expirado: '/acionamento/expirado',
  acionamento_finalizado: '/acionamento/finalizado',
  valor_excedente: '/excedentes',
  valor_excedente_finalizado: '/excedentes/finalizado',
};
